module.exports = reduce

var objectKeys = require('object-keys');

function reduce(list, iterator) {
    var keys = objectKeys(list)
        , i = 0
        , accumulator = list[0]
        , context = this

    if (arguments.length === 2) {
        i = 1
    } else if (arguments.length === 3) {
        accumulator = arguments[2]
    } else if (arguments.length >= 4) {
        context = arguments[2]
        accumulator = arguments[3]
    }

    for (var len = keys.length; i < len; i++) {
        var key = keys[i]
            , value = list[key]

        accumulator = iterator.call(context, accumulator, value, key, list)
    }

    return accumulator
}




//////////////////
// WEBPACK FOOTER
// ../~/reduce/index.js
// module id = 918
// module chunks = 0